export const version = '0.773.0'
export const chameleonWebVersion = '9.6.1'
export const chameleonCoreVersion = '7.8.0'
